module.exports = __webpack_public_path__ + "static/Bitmap_3.f8f503cd.png";